import React from 'react'

const Tab = ({ title, errorsCount = 0 }) => (
  <div className="flex items-center font-medium text-gray-600">
    <span>{title}</span>

    {!!errorsCount && (
      <div className="ml-2 -my-4 text-white bg-red-400 text-xs font-semibold rounded-full h-5 px-2 flex items-center justify-center leading-none">
        {errorsCount}
      </div>
    )}
  </div>
)

export default Tab
